import { useMemo } from 'react';
import { useHomeSections, useSessionStore } from '@room/shared-ui';
import './HomePage.css';

export function HomePage() {
  const sections = useHomeSections();
  const userRole = useSessionStore((state) => state.user?.role);

  const resolvedSections = useMemo(() => {
    return sections.map((section) => ({
      ...section,
      items: section.items.filter((tile) => (tile.visible ? tile.visible() : true)),
    }));
  }, [sections, userRole]);

  const mainSection = resolvedSections.find((section) => section.id === 'main');
  const dockSection = resolvedSections.find((section) => section.id === 'dock');
  const tilesPerPage = 12;
  const mainPages = useMemo(() => {
    const items = mainSection?.items ?? [];
    const pages: typeof items[] = [];
    for (let index = 0; index < items.length; index += tilesPerPage) {
      pages.push(items.slice(index, index + tilesPerPage));
    }
    return pages.length > 0 ? pages : [[]];
  }, [mainSection?.items]);

  return (
    <div className="home-screen">
      <div className="home-screen__pages" aria-label="Home pages">
        {mainPages.map((page, pageIndex) => (
          <div key={`home-page-${pageIndex}`} className="home-screen__page">
            <div className="home-screen__grid">
              {page.map((tile) => (
                <a key={tile.id} href={tile.route} className="home-tile">
                  <div className="home-tile__icon">
                    <span>{tile.icon}</span>
                    {tile.badge && tile.badge() ? (
                      <span className="home-tile__badge">{tile.badge()}</span>
                    ) : null}
                  </div>
                  <div className="home-tile__label">{tile.label}</div>
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>

      {mainPages.length > 1 ? (
        <div className="home-screen__page-indicator" aria-hidden="true">
          {mainPages.map((_, index) => (
            <span key={`home-dot-${index}`} className="home-screen__dot" />
          ))}
        </div>
      ) : null}

      <div className="home-screen__dock">
        {dockSection?.items.map((tile) => (
          <a key={tile.id} href={tile.route} className="home-tile home-tile--dock">
            <div className="home-tile__icon">
              <span>{tile.icon}</span>
              {tile.badge && tile.badge() ? (
                <span className="home-tile__badge">{tile.badge()}</span>
              ) : null}
            </div>
            <div className="home-tile__label">{tile.label}</div>
          </a>
        ))}
      </div>
    </div>
  );
}
